export default __webpack_public_path__ + "static/media/Splash_Right.516dab2a.gif";